import { z } from 'zod';
import { QuoteToolPreselectedModes } from '@lx/shared/utils';

export const PaymentDeepLinkParametersSchema = z
  .object({
    preselectedMode: z.enum(QuoteToolPreselectedModes),
    leadId: z.string(),
    token: z.string(),
  })
  .partial()
  .required({
    preselectedMode: true,
    leadId: true,
    token: true,
  });
